<template>
  <div class="containerInformation table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      工單資訊
    </li>
    <b-table
      :items="containerInformationItem"
      :fields="containerInformationFields"
      class="text-center containerInformation-table-detail"
    >
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "containerInformation",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      containerInformationFields:
        "containerInformation/get_containerInformationFields",
      containerInformationItem:
        "containerInformation/get_containerInformationItem",
    }),
  },
};
</script>

<style lang="scss">
.containerInformation-table-detail thead th {
  border-top: 1px solid;
}
.containerInformation-table-detail th,
.containerInformation-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  background-color: #ffffff;
  vertical-align: middle !important;
}
.containerInformation-table-detail th:first-child,
.containerInformation-table-detail td:first-child {
  border-left: 1px solid;
}
.containerInformation-table-detail {
  margin-bottom: 0px;
}
.containerInformation-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
</style>



// WEBPACK FOOTER //
// src/components/containerInformation.vue